import * as React from 'react';
import styled, { css } from 'styled-components';
import { themeGet } from '@styled-system/theme-get';
import { space } from 'styled-system';

const SVG = (props) => (
  <svg
    width="1em"
    height="1em"
    viewBox="0 0 56 56"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}>
    <path
      d="M20 11a1 1 0 011-1h10a1 1 0 110 2H21a1 1 0 01-1-1zM21 15a1 1 0 100 2h20a1 1 0 100-2H21z"
      fill="#000"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M22.556 4h14.888c1.643 0 2.937 0 3.978.085 1.063.087 1.95.267 2.756.678a7 7 0 013.059 3.06c.41.805.591 1.692.678 2.755.085 1.041.085 2.335.085 3.978v23.087c0 1.084 0 1.958-.058 2.666-.06.729-.185 1.369-.487 1.961a5 5 0 01-2.185 2.185c-.592.302-1.233.428-1.961.487C42.6 45 41.727 45 40.643 45H16.5a2.5 2.5 0 000 5H47a1 1 0 110 2H16.5a4.5 4.5 0 01-4.5-4.5v-5.58c-.916-.146-1.755-.493-2.428-.999C8.658 40.236 8 39.214 8 38c0-1.214.658-2.236 1.572-2.921.674-.506 1.512-.853 2.428-1v-.158c-.916-.147-1.755-.494-2.428-1C8.658 32.236 8 31.214 8 30c0-1.214.658-2.236 1.572-2.921.674-.506 1.512-.853 2.428-1v-.158c-.916-.147-1.755-.494-2.428-1C8.658 24.236 8 23.214 8 22c0-1.214.658-2.236 1.572-2.921.674-.506 1.512-.853 2.428-1v-.158c-.916-.147-1.755-.494-2.428-1C8.658 16.236 8 15.214 8 14c0-1.214.658-2.236 1.572-2.921.707-.53 1.596-.887 2.565-1.02.102-.838.284-1.566.626-2.237a7 7 0 013.06-3.059c.805-.41 1.692-.591 2.755-.678C19.619 4 20.913 4 22.556 4zM14 36.118a3.39 3.39 0 011.228.56c.535.402.772.879.772 1.322a1 1 0 102 0c0-1.214-.658-2.236-1.572-2.921-.674-.506-1.512-.853-2.428-1v-5.961a3.39 3.39 0 011.228.56c.535.401.772.879.772 1.322a1 1 0 102 0c0-1.214-.658-2.236-1.572-2.921-.674-.506-1.512-.853-2.428-1v-5.961a3.39 3.39 0 011.228.56c.535.401.772.879.772 1.322a1 1 0 102 0c0-1.214-.658-2.236-1.572-2.921-.674-.506-1.512-.853-2.428-1V14.6c0-.97 0-1.783.015-2.479.477.119.89.316 1.213.558.535.4.772.878.772 1.321a1 1 0 102 0c0-1.214-.658-2.236-1.572-2.921a5.466 5.466 0 00-2.28-.974c.085-.59.214-1.016.397-1.375a5 5 0 012.185-2.185c.477-.243 1.072-.39 2.01-.467C19.692 6.001 20.904 6 22.6 6h14.8c1.697 0 2.909 0 3.86.078.938.077 1.533.224 2.01.467a5 5 0 012.185 2.185c.243.477.39 1.072.467 2.01.077.951.078 2.163.078 3.86v23c0 1.137 0 1.929-.051 2.546-.05.605-.142.953-.276 1.216a3 3 0 01-1.311 1.311c-.263.134-.611.226-1.216.276-.617.05-1.41.051-2.546.051H16.5c-.925 0-1.785.28-2.5.758v-7.64zm-2 0a3.39 3.39 0 00-1.228.56C10.237 37.08 10 37.558 10 38c0 .443.237.92.772 1.321a3.39 3.39 0 001.228.561v-3.764zm-1.228-4.797a3.39 3.39 0 001.228.561v-3.764a3.39 3.39 0 00-1.228.56C10.237 29.08 10 29.558 10 30c0 .443.237.92.772 1.321zM12 20.118a3.39 3.39 0 00-1.228.56C10.237 21.08 10 21.558 10 22c0 .443.237.92.772 1.321a3.39 3.39 0 001.228.561v-3.764zm-1.228-4.797a3.39 3.39 0 001.228.561v-1.326c0-.917 0-1.726.015-2.442-.49.117-.914.318-1.243.565-.535.4-.772.878-.772 1.321 0 .443.237.92.772 1.321z"
      fill="#000"
    />
    <path
      d="M8.007 3a1 1 0 10-2 0v2H5a1 1 0 000 2h1.007v2a1 1 0 002 0V7H9a1 1 0 100-2h-.993V3z"
      fill="#FFE249"
    />
    <path
      d="M23 23a1 1 0 10-2 0v1.966h-1a1 1 0 100 2h1V29a1 1 0 102 0v-2.034h1a1 1 0 100-2h-1V23z"
      fill="#d5ff4f"
    />
    <path
      d="M53.002 9a1 1 0 10-2 0v2H50a1 1 0 100 2h1.002v2a1 1 0 102 0v-2h1.002a1 1 0 100-2h-1.002V9z"
      fill="#1F77F9"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M55.167 19.776a2.74 2.74 0 01.053 3.874L40.29 38.992 36.37 39l-6.986-7.123a2.74 2.74 0 113.912-3.837l5.022 5.121L51.293 19.83a2.74 2.74 0 013.874-.053z"
      fill="#28D898"
    />
  </svg>
);

const SIZE = 56;
const CAN_SET_COLOR = false;
const SvgRecordbookColor56 = styled(SVG)`
  min-height: ${SIZE}px;
  min-width: ${SIZE}px;
  max-height: ${SIZE}px;
  max-width: ${SIZE}px;
  cursor: ${(p) => (p.$pointer || p.onClick ? 'pointer' : 'default')};
  ${(p) =>
    CAN_SET_COLOR &&
    css`
      path {
        fill: ${themeGet(`colors.${p.color}`, p.color)};
      }
    `}
  ${space}
`;
export default SvgRecordbookColor56;
